import { observable, set } from 'mobx';
import { formatDateValue, formatPoints } from '~utils/FormatterUtils';
import { pascalCaseData } from '~utils/CaseUtils';
import { IPointsHistoryResponse } from '~api/interfaces/IPointsHistoryResponse';

class PointsHistory {
    @observable public transPoints: number = 0;
    @observable public order: number = 0;
    @observable public transOrderId: string = '';
    @observable public transDate: string = '';
    @observable public transType: string = '';
    @observable public transTypeString: string = '';
    @observable public transSubType: string = '';
    @observable public transSubTypeString: string = '';
    @observable public pointsList: string[] = [];
    @observable public remainingRows: number = 0;
    @observable public endCursor: string = '';
    @observable public type: string = '';
    @observable public fromTier: number = 0;
    @observable public toTier: number = 0;
    @observable public pending: boolean = false;
    @observable public currentPoints: number = 0;

    static fromJSON(pointsHistoryResponse: IPointsHistoryResponse): PointsHistory {
        const pointHistory = new PointsHistory();
        const { history, loyaltyLevelCurrent } = pointsHistoryResponse.user.loyalty;

        const pointsList = history.map((pointsDetail) => ({
            transPoints: formatPoints(pointsDetail?.points as number),
            transType: pascalCaseData(pointsDetail?.transType as string, false),
            transTypeString: pointsDetail?.transTypeString as string,
            transSubType: pascalCaseData(pointsDetail?.transSubType as string, false),
            transSubTypeString: pointsDetail?.transSubTypeString as string,
            transDate: formatDateValue(pointsDetail?.date as string),
            order: pointsDetail?.order as number,
            transOrderId: pointsDetail?.transOrderId as string,
            type: pascalCaseData(pointsDetail?.type as string, true),
            fromTier: pointsDetail?.fromTier as number,
            toTier: pointsDetail?.toTier as number,
            pending: pointsDetail?.pending as boolean
        }));

        const pointsHistoryUpdatedData = { pointsList, currentPoints: loyaltyLevelCurrent?.points?.currentAvailable || '0'};
        set(pointHistory, pointsHistoryUpdatedData);

        return pointHistory;
    }
}

export default PointsHistory;
